(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("case-import", {
                parent: "admin",
                url: "/case-import",
                data: {
                    authorities: ["ROLE_USER_ADMIN"],
                    pageTitle: "global.menu.entityImport",
                },
                views: {
                    "content@": {
                        templateUrl: "app/admin/case-import/case-import.html",
                        controller: "CaseImportController",
                        controllerAs: "vm",
                    },
                },
                reloadOnSearch: false,   // ✅ IMPORTANT
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
                }
            })

            .state('case-import.new', {
                parent: 'case-import',
                url: '/case-import',
                data: {
                    authorities: ['ROLE_USER_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/case-import/case-import-dialog.html',
                        controller: 'CaseImportDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    previousState: ["$state", function ($state) {
                        return $state.current.name || 'case-import';
                    }]
                }
            })
        }
    })();